// extracted by mini-css-extract-plugin
export default {"container":"dropdown_container__DAG23","menu":"dropdown_menu__WNojc"};